import React from "react";
import {
  Tabel,
  Badge,
  DropDown,
  DropDownMenu,
  Typography,
  Modal,
} from "../core";
import { reducer, initialState } from "../hooks/modalReducer";
import { useSelector, useDispatch } from "react-redux";
import DeleteModal from "../components/DeleteModal";
import { Menu, Form } from "antd";
import { theme } from "../styles";
import EditPayment from "./EditPayment";
import { deletePayment } from "../redux/Action/payment";
import { getCompanyId } from "../helper/utils/companyId";
const CHANGE_DATE_FORMAT = require("../helper/utils/datFormat");
const { textColor } = theme;
const typoProps = {
  as: "h3",
  weight: "bold",
  letterSpacing: "0.2px",
  color: textColor.primary,
  text: "Payment History",
};
const PaymentColumns = [
  {
    title: "Date",
    dataIndex: "payment_date",
    key: "payment_date",
    render: (text, record, index) => {
      return (
        <span>{CHANGE_DATE_FORMAT.changeDateFormat(record.payment_date)}</span>
      );
    },
    width: 150,
  },

  {
    title: "Amount",
    dataIndex: "payment_amount",
    key: "payment_amount",
    width: 150,
  },
  {
    title: "Payment Method",
    dataIndex: "payment_method",
    key: "payment_method",
    width: 150,
  },

  {
    title: "Payment Status",
    dataIndex: "payment_option",
    key: "payment_option",
    render: (text) => <Badge status={text} text={text}></Badge>,
    width: 150,
  },
  // {
  //   title: "WHT Chalan",
  //   dataIndex: "wht_chalan",
  //   key: "wht_chalan",
  //   render: (text) => <Badge status={text} text={text}></Badge>,
  //   width: 150,
  // },
  {
    title: "Action",
    dataIndex: "action",
    width: 150,
    render: (text, record, index) => (
      <DropDown overlay={<MenuCompo index={index} record={record} />} />
    ),
  },
];

const PaymentHistory = ({ className, ...props }) => {
  React.useEffect(() => {}, []);
  const payments = useSelector((state) => state.payments.payments);

  return (
    <React.Fragment>
      <Typography {...typoProps} />
      <Tabel
        className={className}
        padding="0px;"
        pagination={false}
        columns={PaymentColumns}
        data={payments}
      />
    </React.Fragment>
  );
};
const MenuCompo = (params) => {
  const { token } = useSelector((state) => state.auth);
  const dispatchtoAction = useDispatch();
  const { record } = params;
  const [form] = Form.useForm();
  const [paymentId, setPaymentId] = React.useState(null);
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const onCreate = () => {
    dispatch({ type: "MODAL_VIEW", payload: false });
  };
  const onCancel = () => {
    dispatch({ type: "MODAL_VIEW", payload: false });
  };
  const menuClick = ({ item, key }) => {
    setPaymentId({ id: item.props.id });
    return key === "delete_payment"
      ? dispatch({
          type: "MODAL_VIEW",
          payload: { flag: true, modal_name: key },
        })
      : key === "edit_payment"
      ? dispatch({
          type: "MODAL_VIEW",
          payload: { flag: true, modal_name: key },
        })
      : null;
  };
  const delete_func = () => {
    // console.log(paymentId);
    dispatchtoAction(
      deletePayment(paymentId.id, getCompanyId() || record.company_id, token)
    );
  };
  return (
    <>
      {state.modal_name === "delete_payment" ? (
        <Modal
          closable={true}
          footer={false}
          visible={state.visible}
          maxwidth="550px"
          tittle="Are You Sure you want to delete this Payment"
        >
          <DeleteModal
            id_to_delete={paymentId}
            onCancel={onCancel}
            delete_func={delete_func}
          />
        </Modal>
      ) : state.modal_name === "edit_payment" ? (
        <Modal
          closable={true}
          footer={false}
          visible={state.visible}
          onCreate={onCreate}
          tittle="Edit Payment"
        >
          <EditPayment
            paymentId={paymentId}
            onCreate={onCreate}
            onCancel={onCancel}
            form={form}
          />
        </Modal>
      ) : null}
      <DropDownMenu onClick={menuClick}>
        <Menu.Item key="delete_payment" id={record.payment_id}>
          Delete
        </Menu.Item>
        <Menu.Item key="edit_payment" id={record.payment_id}>
          Edit
        </Menu.Item>
      </DropDownMenu>
    </>
  );
};

export default PaymentHistory;
